import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi, useAuth } from '../../../hooks';
import { UpdateClaimRiskStrat } from '../../../models/claimRiskStrat';

export const useUpdateClaimRiskStrat = (userId: string) => {
  const { api } = useApi({ throwIfError: true });
  const queryClient = useQueryClient();
  const { userToken } = useAuth();

  const mutation = useMutation({
    mutationFn: async (payload: UpdateClaimRiskStrat) => {
      return await api({
        route: `/private/dashboard/user/${userId}/claim-risk-strat`,
        method: 'PATCH',
        payload,
        token: userToken,
      });
    },

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['claim-risk-strat'],
      });
    },
  });

  return {
    mutation,
  };
};

export default useUpdateClaimRiskStrat;
